<template>
  <v-container fluid grid-list-md>
    <reports-data-grouping
      :defaultDataGrouping="defaultDataGrouping"
      :additionalDataGrouping="additionalDataGrouping"
      :hasClasses="hasClasses"
      :groupByClass="groupByClass"
      @update-default="$emit('update-default', $event)"
      @update-additional="$emit('update-additional', $event)"
      :coverageGroups="coverageGroups"
      @update-coverage-groups="$emit('update-coverage-groups', $event)"
      :coverage="coverage"
      @valid="valid.reportGroups = $event"
      :disabled="disabled"
      :planInsuranceCarriers="planInsuranceCarriers"
      @plan-insurance-carriers="$emit('plan-insurance-carriers', $event)"
    />
    <reports-display-settings
      :reportConfiguration="reportConfiguration"
      @valid="valid.reports = $event"
      :hasBilling="hasBilling"
      :disabled="disabled"
    />
    <reports-address
      :reportConfiguration="reportConfiguration"
      :reportConfigurationAddress="reportConfigurationAddress"
      @valid="valid.reportAddress = $event"
      @update-address="$emit('update-address', $event)"
      :disabled="disabled"
    />
  </v-container>
</template>

<script>
import ReportsDataGrouping from "@/components/PlanBuilder/ReportsDataGrouping.vue";
import ReportsDisplaySettings from "@/components/PlanBuilder/ReportsDisplaySettings.vue";
import ReportsAddress from "@/components/PlanBuilder/ReportsAddress.vue";

export default {
  components: { ReportsDataGrouping, ReportsDisplaySettings, ReportsAddress },
  props: [
    "defaultDataGrouping",
    "additionalDataGrouping",
    "reportConfiguration",
    "hasBilling",
    "hasClasses",
    "groupByClass",
    "coverageGroups",
    "coverage",
    "reportConfigurationAddress",
    "disabled",
    "planInsuranceCarriers"
  ],
  mounted() {
    this.$emit(
      "valid",
      this.valid.reports && this.valid.reportAddress && this.valid.reportGroups
    );
  },
  data() {
    return {
      valid: {
        reports: false,
        reportAddress: false,
        reportGroups: false,
      },
    };
  },
  watch: {
    valid: {
      handler(v) {
        this.$emit(
          "valid",
          this.valid.reports &&
            this.valid.reportAddress &&
            this.valid.reportGroups
        );
      },
      immediate: true,
      deep: true,
    },
    // "valid.reports": {
    //   handler(v) {
    //     this.$emit("valid", v && this.valid.reportAddress && this.valid.reportGroups);
    //   },
    // },
    // "valid.reportAddress": {
    //   handler(v) {
    //     this.$emit("valid", v && this.valid.reports  && this.valid.reportGroups);
    //   },
    // },
    // "valid.reportGroups": {
    //   handler(v) {
    //     this.$emit("valid", v && this.valid.reports  && this.valid.reportAddress);
    //   },
    // },
  },
};
</script>
